import FormattedMessage from 'I18n/components/FormattedMessage';
import FieldWithLabelAndValue from './atomic/FieldWithLabelAndValue';
import { HIGHLIGHT_PIPELINE } from '../../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
const Pipeline = ({
  value
}) => /*#__PURE__*/_jsx(FieldWithLabelAndValue, {
  "data-test-id": HIGHLIGHT_PIPELINE,
  label: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "highlightCard.propertyLabels.pipeline"
  }),
  value: value
});
export default Pipeline;